import { render, staticRenderFns } from "./IconPdf.vue?vue&type=template&id=6394a2f8&"
import script from "./IconPdf.vue?vue&type=script&lang=js&"
export * from "./IconPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports